export class MaintenanceItem {
  id: number;
  module: string;
  disabledBy: string;
  route: string;
  disabledAt: Date;
  adminOverride?: boolean;
  disabledMessage?: string;
}
